import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.dispatchEvent.bind(this))
    document.addEventListener("turbo:render", this.blockPrefetch.bind(this))
    this.blockPrefetch()
  }

  disconnect() {
    document.removeEventListener("turbo:render", this.blockPrefetch.bind(this))
  }

  get openModalEvent() {
    return new CustomEvent("modal:open", {
      detail: {
        title: this.element.title,
        url: this.element.href,
      }
    })
  }

  get modal() {
    return document.getElementById("modal-component")
  }

  dispatchEvent(event) {
    event.preventDefault()
    this.modal?.dispatchEvent(this.openModalEvent)
  }

  blockPrefetch(event) {
    this.element.setAttribute("data-turbo-prefetch", "false")
  }
}
